module.exports = __webpack_public_path__ + "img/Protection.93971d1b.svg";